import {
  AvailabilityFiltersResponse,
  FilterResponse
} from "./AvailabilityFiltersResponse";

export class AvailabilityFilters {
  routes: Filter[];
  vehicles: Filter[];

  constructor(resp: AvailabilityFiltersResponse) {
    this.routes = resp.routes.map((r) => new Filter(r));
    this.vehicles = resp.vehicles.map((v) => new Filter(v));
  }
}

export class Cabins {
  cabins: Filter[];

  constructor(resp: FilterResponse[]) {
    this.cabins = resp.map((r) => new Filter(r));
  }
}

export class Filter {
  label: string;
  value: string;

  constructor(resp: FilterResponse) {
    this.label = resp.name;
    this.value = resp.code;
  }
}

export type FilterState = {
  route: string;
  cabin: string;
  vehicle: string;
};

export type CalendarState = {
  month: number;
  year: number;
};
